import { from } from '@apollo/client';
import errorLink from './error';
import httpLink from './http';
import retryLink from './retry';

const links = from([retryLink(), errorLink(), httpLink()]);

export default links;
